import React from 'react';
import { RuleLayout } from '../../rule-layout';
export const CustomRuleFixer = _ref => {
  let {
    ruleResult
  } = _ref;
  const {
    customFixer
  } = ruleResult.fixerProps;
  if (! /*#__PURE__*/React.isValidElement(customFixer)) {
    console.error('customFixer is not a valid React element');
    return null;
  }
  return /*#__PURE__*/React.createElement(RuleLayout, {
    description: ruleResult.description
  }, customFixer);
};
//# sourceMappingURL=custom-fixer.js.map